export const DATE_VARIANTS = {
  SHORT: "SHORT",
  SHORT_DAY_MONTH: "SHORT_DAY_MONTH",
  SHORT_TIME: "SHORT_TIME",
  DOT_TIME: "DOT_TIME",
  TIME: "TIME",
  ISO: "ISO",
};

const FORMATS = {
  // "01 Jan 2024"
  [DATE_VARIANTS.SHORT]: {
    day: "2-digit",
    month: "short",
    year: "numeric",
  },
  // "01 Jan"
  [DATE_VARIANTS.SHORT_DAY_MONTH]: {
    day: "2-digit",
    month: "short",
  },
  // "01 Jan 2024, 14:30"
  [DATE_VARIANTS.SHORT_TIME]: {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  },
  // "14:30"
  [DATE_VARIANTS.TIME]: {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  },
  // "2024-01-01"
  [DATE_VARIANTS.ISO]: {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
};

const toDate = (date) => {
  if (date instanceof Date) {
    return date;
  }

  if (Array.isArray(date)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = date;
    return new Date(year, month - 1, day, hour, minute, second);
  }

  return new Date(date);
};

export const formatDate = (date, format = DATE_VARIANTS.SHORT) => {
  if (!date) {
    return null;
  }

  const validDate = toDate(date);
  if (Number.isNaN(validDate.getTime())) {
    return null;
  }

  const isDotTime = format === DATE_VARIANTS.DOT_TIME;
  const intlFormat = isDotTime ? DATE_VARIANTS.SHORT_TIME : format;

  const formatted = new Intl.DateTimeFormat(
    "en-GB",
    FORMATS[intlFormat]
  ).format(validDate);

  if (format === DATE_VARIANTS.ISO) {
    const [day, month, year] = formatted.split("/");
    return `${year}-${month}-${day}`;
  }

  if (isDotTime) {
    return formatted.replace(",", " ·");
  }

  return formatted;
};
